//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { detectIncognito } from 'detectincognitojs';

export default {
  name: 'GdprConsentBanner',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showBanner: false,
    };
  },
  mounted() {
    this.checkIncognitoAndLoadCustomGDPR();
  },
  methods: {
    async checkIncognitoAndLoadCustomGDPR() {
      const result = await detectIncognito();
      if (result.isPrivate && result.browserName === 'Safari') {
        console.log('Incognito mode detected in Safari');
        this.showBanner = true;
      } else {
        console.log('Incognito mode not detected or not in Safari');
        this.showBanner = false;
      }
    },
    closeBanner() {
      this.showBanner = false;
    },
  },
};
